
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { GenericDocTemplateContainerModel } from '../../../../../../models/aggregates/generic_doc';

export class GenericDocTemplateService extends BaseApiTemplateService<GenericDocTemplateContainerModel> {
  public docType: string;

  constructor(http: HttpClient, docType: string) {
    super();
    this.docType = docType;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_DOC_PREFIX;
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}${Core2Config.GENERIC_DOC_PREFIX}${Core2Config.TEMPLATES_PREFIX}${this.docType}/backoffice-ep`;
    this.httpClient = http;
  }
}
